import React, { FC } from 'react';
import { CrewMember } from '@bechtel/types';
import { AvatarRegularStyled, OwnerNameStyled, ForemanCollapsedStyled } from './styled';
import { Box, Text } from '@bechtel/gds';
import { useName, usePlanning, TextWithEllipsis, EllipsisPlacement } from '@bechtel/client-common';
import { lowerCase, startCase } from 'lodash';

interface CrewMemberItemProps {
  crewMember: CrewMember;
}
const CrewMemberItem: FC<CrewMemberItemProps> = ({ crewMember }) => {
  const { getFullName } = useName();
  return (
    <Box flexDirection={{ sm: 'column' }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'space-between' }}>
      <AvatarRegularStyled
        hasImageUrl={crewMember.imageUrl ? true : false}
        src={crewMember.imageUrl ? crewMember.imageUrl : undefined}
      />
      <OwnerNameStyled>
        <TextWithEllipsis size="300" color="grey.1000" weight="600" ellipsisPlacement={EllipsisPlacement.END}>
          {getFullName(crewMember?.firstName, crewMember?.lastName)}
        </TextWithEllipsis>
      </OwnerNameStyled>
      <Text size="200" color="grey.1000">
        {crewMember.persona && startCase(lowerCase(crewMember.persona))}
      </Text>
    </Box>
  );
};
interface ForemanCollapsedProps {
  hidden: boolean;
}
export const ForemanCollapsed: FC<ForemanCollapsedProps> = ({ hidden }) => {
  const { selectedForeman, selectedGeneralForeman, selectedSuperintendent } = usePlanning();
  return (
    <ForemanCollapsedStyled hidden={hidden}>
      <CrewMemberItem crewMember={selectedSuperintendent} />
      <CrewMemberItem crewMember={selectedGeneralForeman} />
      <CrewMemberItem crewMember={selectedForeman} />
    </ForemanCollapsedStyled>
  );
};
